import { Card } from 'components/TeamOverview/components/Common/Card/Card';
import { useState } from 'react';
import { BlockManagerDefaultView } from 'components/TeamOverview/BillingSection/views/BlockManagerDefaultView/BlockManagerDefaultView';
import { BILLING_TAB } from 'components/TeamOverview/BillingSection/utilities/constants';
import { useBillingSectionStyles } from 'components/TeamOverview/BillingSection/styles';
import { BillingSectionHeader } from 'components/TeamOverview/BillingSection/BillingSectionHeader';

export const BillingSection = ({ team }) => {
  const { classes } = useBillingSectionStyles();
  const [filter, setFilter] = useState(BILLING_TAB.ALL);

  return (
    <Card
      cardClass={classes.card}
      header={
        <BillingSectionHeader
          team={team}
          filter={filter}
          setFilter={setFilter}
        />
      }
    >
      <BlockManagerDefaultView team={team} filter={filter} />
    </Card>
  );
};
